/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { SetBackStyle, SetCurrentTab, SetScrolling, ToggleDialog, ToggleNav, UIState } from '../types/ui.types';

const toggleDialog: CaseReducer<UIState, PayloadAction<ToggleDialog>> = (state, action) => {
  if (action.payload.msg !== "" && action.payload.msg !== undefined && action.payload.msg !== null) {
    state.toggleDialog = true;
  } else {
    state.toggleDialog = false;
  }
  state.type = action.payload.type;
  state.msg = action.payload.msg;
}

const setScrolling: CaseReducer<UIState, PayloadAction<SetScrolling>> = (state, action) => {
  state.scrollY = action.payload.value;
}

const setBackStyle: CaseReducer<UIState, PayloadAction<SetBackStyle>> = (state, action) => {
  if (state.backStyle === false || (action.payload.backStyle === false)) {
    state.backStyle = action.payload.backStyle;
    state.title = action.payload.backStyle ? action.payload.title! : ''
  }
}

const toggleNav: CaseReducer<UIState, PayloadAction<ToggleNav>> = (state, action) => {
  state.toggle = !state.toggle;
}

const setCurrentTab: CaseReducer<UIState, PayloadAction<SetCurrentTab>> = (state, action) => {
  state.currentTab = action.payload.id
}

export default {
  toggleDialog,
  toggleNav,
  setBackStyle,
  setScrolling,
  setCurrentTab
}